import './Advances.scss'

import { Col, Row } from 'react-bootstrap';
import { LeadingActions, SwipeAction, SwipeableList, SwipeableListItem, TrailingActions } from 'react-swipeable-list';
import React, { useEffect, useState } from 'react';
import { faAdd, faEdit, faMoneyBillWave, faTrash } from '@fortawesome/free-solid-svg-icons';
import { formatDate, formatDateInEN, formatDateTime, formatInReal } from '../../../commons/util/HallAppUtil';

import AdvancesAPI from '../AdvancesAPI';
import AdvancesModal from './AdvancesModal';
import CashClosingFilter from '../components/CashClosingFilter';
import ConfirmModal from '../../../commons/modal/ConfirmModal';
import EmptyState from '../../../commons/EmptyState';
import FloatingButton from '../../../commons/buttons/FloatingButton';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import HallAppToast from '../../../commons/HallAppToast';
import MenuTitle from '../../../commons/menu/MenuTitle';
import ReportHeader from '../../report-full/components/ReportHeader';
import ReportValues from '../../report/components/ReportValues';
import { useParams } from 'react-router-dom';

/* eslint-disable react-hooks/exhaustive-deps */
const advancesAPI = new AdvancesAPI();

const Advances = () => {
    const [showModalAddAdvances, setShowModalAddAdvances] = useState(false)
    const { employeeId } = useParams();
    const [loading, setLoading] = useState(true);
    const [advances, setAdvances] = useState([]);
    const [currentItem, setCurrentItem] = useState({});
    const [showModalDelete, setShowModalDelete] = useState(false)
    const [isLoadingModalDelete, setIsLoadingModalDelete] = useState(false)
    const [totalDiscounted, setTotalDiscounted] = useState(0)
    const [totalToDiscount, setTotalToDiscount] = useState(0)

    const today = new Date();

    // Primeiro dia da semana (domingo)
    const firstDayOfWeek = new Date(today);
    firstDayOfWeek.setDate(today.getDate() - today.getDay());

    // Último dia da semana (sábado)
    const lastDayOfWeek = new Date(today);
    lastDayOfWeek.setDate(today.getDate() + (6 - today.getDay()));

    const [filter, setFilter] = useState({
        startDate: formatDateInEN(firstDayOfWeek),
        endDate: formatDateInEN(lastDayOfWeek),
        employeeId: employeeId
    });


    useEffect(() => {
        findAll();
    }, [filter]);

    const findAll = async () => {
        try {
            const resp = await advancesAPI.findAll(filter);
            setAdvances(resp.data);
            const totalValue = resp.data.filter((item) => item.discountDate).reduce((acc, item) => acc + item.value, 0);
            const totalToDiscountValue = resp.data.filter((item) => !item.discountDate).reduce((acc, item) => acc + item.value, 0);

            setTotalToDiscount(totalToDiscountValue)
            setTotalDiscounted(totalValue)

        } catch (_) {
            HallAppToast.genericError();
        } finally {
            setLoading(false)
        }
    }

    async function executeDeletion() {
        setIsLoadingModalDelete(true)
        try {
            await advancesAPI.delete(currentItem.id);
            setIsLoadingModalDelete(false)
            setShowModalDelete(false)
            HallAppToast.success();
            findAll()
        } catch (_) {
            HallAppToast.genericError();
            setIsLoadingModalDelete(false)
        } finally {
            setIsLoadingModalDelete(false)
        }
    }

    const editAction = (item) => (
        <LeadingActions>
            <SwipeAction onClick={() => {
                setCurrentItem(item);
                setShowModalAddAdvances(true)
            }}>
                <div className="swipe">
                    <div className="swipe swipe-edt">
                        <FontAwesomeIcon icon={faEdit} size="lg" />
                        <div>EDITAR</div>
                    </div>
                </div>
            </SwipeAction>
        </LeadingActions>
    );

    const deleteAction = (item) => (
        <TrailingActions>
            <SwipeAction
                destructive={false}
                onClick={() => {
                    setCurrentItem(item);
                    setShowModalDelete(true);
                }}
            >
                <div className="swipe">
                    <div className="swipe swipe-dlt">
                        <FontAwesomeIcon icon={faTrash} size="lg" />
                        <div>EXCLUIR</div>
                    </div>
                </div>
            </SwipeAction>
        </TrailingActions>
    );


    function changeDates(startDate, endDate) {
        if (endDate === null) {
            endDate = startDate;
        }
        setFilter({
            ...filter,
            startDate: startDate,
            endDate: endDate
        })
    }


    return (
        <>
            <ReportHeader name='Adiantamentos' />
            <div
                style={{
                    position: 'fixed',
                    top: 60,
                    left: 0,
                    right: 0,
                    zIndex: 9999,
                    marginTop: '0',
                    paddingTop: '0',
                    display: 'block',
                    backgroundColor: 'white',
                }}
                className="filter-my-command"
            >
                {!showModalAddAdvances && <CashClosingFilter changeDates={changeDates} />}
            </div>

            <div style={{ marginTop: '60px' }}></div>

            <div className="container mt-4" >

                <MenuTitle title="Adiantamentos" showArrowInfo={true} />
                <Row className="mb-3">
                    <Col xs={12} md={6} className="mb-3">
                        <ReportValues
                            isLoadingSummary={loading}
                            bgColor="#28a745"
                            value={formatInReal(totalDiscounted)}
                            label="total já descontado"
                        />
                    </Col>
                    <Col xs={12} md={6} className="mb-3">
                        <ReportValues
                            isLoadingSummary={loading}
                            bgColor="red"
                            value={formatInReal(totalToDiscount)}
                            label="total á descontar"
                        />
                    </Col>
                </Row>
                <hr></hr>

                <Row style={{ margin: 0, width: '100%' }}>

                    {advances.length === 0 ? <EmptyState
                        title="Nenhum adiantamento encontrado"
                        description="Você ainda não possui registros de adiantamento neste período. Quando um adiantamento for solicitado e aprovado, ele aparecerá aqui."
                        icon={<FontAwesomeIcon icon={faMoneyBillWave} />}
                        // Se o funcionário puder solicitar um adiantamento pelo app, mantenha a ação abaixo:
                        actionLabel="Solicitar adiantamento"
                        onAction={() => setShowModalAddAdvances(true)}
                    /> : advances.map((item) => (
                        <Col xs={12} sm={12} md={4} lg={4} key={item.id} style={{ marginBottom: '10px' }}>
                            <SwipeableList style={{ width: '100%' }}>
                                <SwipeableListItem
                                    leadingActions={editAction(item)}
                                    trailingActions={deleteAction(item)}
                                    key={item.id}
                                    fullSwipe={false}
                                >
                                    <div key={item.id} className="advance-card card shadow-sm mb-3">
                                        <div className="card-body d-flex justify-content-between align-items-center">
                                            <div className="advance-card__info">
                                                <h6 className="advance-card__title mb-1">
                                                    <strong>{item.employeeName}</strong>
                                                </h6>

                                                <p className="advance-card__meta mb-1">
                                                    <span className="advance-card__label">Criado por:</span>{' '}
                                                    <span className="advance-card__value">{item.responsibleCreate}</span>
                                                </p>

                                                <p className="advance-card__meta mb-1">
                                                    <span className="advance-card__label">Data solicitação:</span>{' '}
                                                    <span className="advance-card__value">{formatDate(item.advanceDate)}</span>
                                                </p>

                                                <p className="advance-card__meta mb-0">
                                                    <span className="advance-card__label">Data desconto:</span>{' '}
                                                    <span className="advance-card__value">
                                                        {item?.discountDate ? formatDateTime(item.discountDate) : '—'}
                                                    </span>
                                                </p>
                                            </div>

                                            <div className="advance-card__amount text-end">
                                                <span className="advance-card__value-amount">{formatInReal(item.value)}</span>
                                            </div>
                                        </div>
                                    </div>
                                </SwipeableListItem>
                            </SwipeableList>

                        </Col>
                    ))}
                </Row>
                <div  style={{ height: "calc(60px + 72px)" }}></div>

            </div>
            <FloatingButton icon={faAdd} onClick={() => {
                setShowModalAddAdvances(true);
            }} />

            {
                showModalDelete && <ConfirmModal show={showModalDelete}
                    title='Excluir'
                    isLoading={isLoadingModalDelete}
                    confirm={executeDeletion}
                    closeModal={() => {
                        setShowModalDelete(false)
                    }}
                >
                    Deseja remover o lançamento?
                </ConfirmModal>
            }


            {
                showModalAddAdvances && <AdvancesModal
                    show={showModalAddAdvances}
                    item={currentItem}
                    callList={findAll}
                    closeShow={() => {
                        setCurrentItem({})
                        setShowModalAddAdvances(false);
                    }} />
            }

        </>

    );
};

export default Advances;
